import { UnknownBlueprint } from '../types';

export const u4 = (inBlueprint: UnknownBlueprint): [UnknownBlueprint, boolean] => {
	console.log('schema-update:process-update:4:unsupported');
	inBlueprint.schemaVersion = 4;
	return [inBlueprint, false];
};
